import { Box, styled, Text } from '@ltvco/refresh-lib/theme';

// Platform availability row — tappable when a URL is present.
export const PlatformRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  minHeight: 44,
  padding: '7px 0',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': { borderBottom: 'none' },
}));

export const PlatformIcon = styled(Box)({
  width: 28,
  height: 28,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const PlatformInitial = styled(Box)(({ theme }) => ({
  width: 28,
  height: 28,
  borderRadius: '50%',
  backgroundColor: theme.palette.button.light,
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 12,
  fontWeight: 700,
}));

export const PlatformName = styled(Text)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.text.primary,
  flex: 1,
  textAlign: 'left',
}));

export const PlatformStatus = styled(Text)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.text.primary,
  flexShrink: 0,
}));

export const PlatformLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  cursor: 'pointer',
  textDecoration: 'none',
  flexShrink: 0,
}));

export const MoreOwnersButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  padding: '14px 4px 2px',
  marginTop: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 14,
  fontWeight: 700,
  color: theme.palette.primary.main,
}));
